import React, { useEffect, useState } from 'react';
import { Card } from '../Card';
import CardTitle from '../Card/CardTitle';
import CardExtra from '../Card/CardExtra';
import Highlighter from 'react-highlight-words';
import styles from './SearchMobileCard.module.scss';
import { Icon } from '../Icon';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { useTranslation } from 'react-i18next';

const SearchMobileCard = ({ video, folders, searchInput, isReview }) => {
  const { t } = useTranslation();

  const [folder, setFolder] = useState(t('folder.my_library.title'));

  useEffect(() => {
    if (isReview) {
      setFolder(t('review.title'));
      return;
    }

    if (video.folder) {
      const videoFolder = folders.find(folder => folder.id === video.folder);
      videoFolder && setFolder(videoFolder.name);
    }
  }, [video, folders]);

  const history = useHistory();

  return (
    <Card className={styles.videoCard} onClick={async () => history.push({ pathname: `/eg/video/${video.id}` })}>
      <div className={styles.cardContainer}>
        <div className={styles.iconContainer}>
          <Icon src="playSign" className={styles.videoIcon} />
        </div>
        <div className={styles.infoWrapper}>
          <CardTitle className={styles.title}>
            <Highlighter
              highlightClassName="wordHighlighter"
              className={styles.titleList}
              searchWords={[searchInput]}
              autoEscape
              textToHighlight={video.name}
            />
          </CardTitle>
          <CardExtra className={styles.cardExtra}>
            <span className={styles.folderName}>{folder}</span>
            <span className={styles.videoDate}>{t('general.date', { date: new Date(`${video.updateDate}`) })}</span>
            <span>{video.source !== 'web' && <span style={{ textTransform: 'capitalize' }}> | {video.source}</span>}</span>
          </CardExtra>
        </div>
      </div>
    </Card>
  );
};

export default SearchMobileCard;
